import Vue from 'vue';
import Vuex from 'vuex';
import {Game} from '@/models/Game';

Vue.use(Vuex);

interface GameState {
	game: Game;
}

/**
 * Store in indexDb an user
 */
class GameStore {
	
	
	public state: GameState = {
		game: new Game(),
	};
	
	public mutations = {
		
		setGame(state: GameState, game: Game) {
			state.game = game;
		},
		
		reset(state: GameState) {
			state.game = new Game();
		}
	};
	
	public actions = {
	};
	
}
const gameStore = new GameStore();

export default new Vuex.Store(gameStore);
